
  import { defineComponent, onUnmounted, ref, toRefs } from 'vue';
  import { Modal, modalProps, ModalProps } from '@/ui/components/Modal';
  import { PageSubtitle } from '@/ui/components/PageSubtitle';
  import ScheduleFormFields from '@/ui/components/schedule/ScheduleFormFields.vue';
  import { useSchedule } from '@/ui/concerns/schedule/useSchedule';
  import { useTask, useValidation } from '@/ui/concerns';
  import { create } from '@/services/api/resources/schedule';
  import { Schedule, validate } from '@/entities/schedule';
  import { Loader } from '@/ui/components/Loader';
  import { Button } from '@/ui/components/Button';
  import emitter from '@/services/emitter';
  import { CREATE_SCHEDULE_MODAL_WIDTH } from '@/ui/components/modals/constants';
  import { useTimeZonedDates } from '@/ui/concerns/useTimeZonedDates';

  export default defineComponent<ModalProps>({
    name: 'CreateScheduleModal',
    components: {
      Loader,
      ScheduleFormFields,
      PageSubtitle,
      Modal,
      Button,
    },
    props: modalProps,
    setup(props, ctx) {
      const { active } = toRefs(props);
      const {
        store,
        entityItemOptions,
        assigneeOptions,
        getOptions,
        updateUserOptions,
      } = useSchedule();

      const { getDateInLocalTimeZone } = useTimeZonedDates();
      store.updateRuleStart(getDateInLocalTimeZone(store.record.rule.start!));

      const record = ref<Schedule>(store.record);

      // send record
      const sendRecord = useTask(
        () => create(store.record),
        response => {
          emitter.emit('scheduleCreated', { response });
          ctx.emit('schedule-created');
        },
      );

      const {
        validationErrors,
        hasNoValidationErrors,
        showValidationErrors,
      } = useValidation(validate, record, sendRecord.state);

      const handleSubmit = () => {
        showValidationErrors.value = true;
        if (hasNoValidationErrors.value) {
          sendRecord.run();
        }
      };

      onUnmounted(() => store.$reset());

      const closeModal = () => {
        ctx.emit('close');
      };

      return {
        modalActive: active,
        getOptions,
        sendRecord,
        entityOptions: entityItemOptions,
        userOptions: assigneeOptions,
        validationErrors,
        hasNoValidationErrors,
        showValidationErrors,
        closeModal,
        handleSubmit,
        updateUserOptions,
        CREATE_SCHEDULE_MODAL_WIDTH,
      };
    },
  });
